import type { Blockchain } from "@anaconda/core/blockchain/types"
import type { PriceValue } from "@anaconda/core/price/types"
import {
  type ExchangeFees,
  getExchangeFeesFactoryReatom,
} from "@rarible_int/anaconda_sdk/ethereum"
import { computed } from "@reatom/core"
import { molecule } from "bunshi"
import { EvmSdkContainerMoleculeReatom } from "../../blockchains/evm-sdk-container-molecule.reatom"

export const EvmFeesMoleculeReatom = molecule((mol) => {
  const { sdkContainerAtom } = mol(EvmSdkContainerMoleculeReatom)

  // Factory: Returns computed atom with TanStack Query params
  const reatomModernFeeQuery = ({
    price,
    blockchain,
  }: {
    price: PriceValue | undefined
    blockchain: Blockchain
  }) =>
    computed(() => {
      return {
        queryKey: ["evm", "fees", price?.amount, price?.currency, blockchain],
        queryFn: async (): Promise<ExchangeFees> => {
          const container = sdkContainerAtom()

          if (!container) {
            throw new Error("EVM SDK Container is not initialized")
          }

          const getExchangeFees = getExchangeFeesFactoryReatom(container)
          const result = await getExchangeFees()
          return result
        },
      }
    }, `modernFeeQuery_${blockchain}_${price?.amount}_${price?.currency}`)

  // Factory: Returns computed atom with async logic (for direct SDK calls)
  function modernFeesAsync({
    price,
    blockchain,
  }: {
    price: PriceValue | undefined
    blockchain: Blockchain
  }) {
    return computed(async () => {
      const container = sdkContainerAtom()

      if (!container) {
        throw new Error("EVM SDK Container is not initialized")
      }

      const getExchangeFees = getExchangeFeesFactoryReatom(container)
      const result = await getExchangeFees()
      return result
    }, `modernFeesAsync_${blockchain}_${price?.amount}_${price?.currency}`)
  }

  return {
    reatomModernFeeQuery,
    modernFeesAsync,
  }
})
